// src/packages/dhipaya/motor/dhipaya_truck_2p3p_2025/index.js
import DhipayaTruckCard from "./DhipayaTruckCard";
import DhipayaTruckDetails from "./DhipayaTruckDetails";
import "./dhipaya_truck.css";

/**
 * Dhipaya — Truck 2+ / 3+ (Codes 320/420/520), effective 01.04.2025
 */
export default {
  id: "dhipaya_truck_2p3p_2025",
  company: "ทิพยประกันภัย (Dhipaya)",    // ต้องตรงกับ COMPANY_INFO
  productLine: "motor",
  categories: ["truck", "2+", "3+"],
  nameTH: "Dhipaya Truck 2+ / 3+ (320/420/520)",
  description: "รถบรรทุกใหญ่ ชั้น 2+ / 3+ แยกตามโค้ดรถและอุปกรณ์ เพิ่ม-ลดตามน้ำหนักและทุน",
  accent: "#004aad",
  expiresAt: "9999-12-31",
  card: DhipayaTruckCard,
  detail: DhipayaTruckDetails,
  active: true,
};
